import '../DynamicFormPage/DynamicFormPage.css';
import './ErrorPage.css';
import { deriveTheme, PASSENTRY_COLORS, themeToCssVars } from '../../theme/formTheme';

type Props = {
  code: number;
  title: string;
  body: string;
  onRetry?: () => void;
};

const theme = deriveTheme(PASSENTRY_COLORS);

export default function CustomErrorMessage({ code, title, body, onRetry }: Props) {
  document.body.style.color = theme.text;
  document.body.style.backgroundColor = theme.page;

  return (
    <div className="error-page" style={themeToCssVars(theme)}>
      <div className="error-card">
        <span className="error-code">Error {code}</span>
        <h1 className="error-title">{title}</h1>
        <p className="error-body">{body}</p>
        {onRetry && (
          <button type="button" className="submit-button error-retry" onClick={onRetry}>
            Try again
          </button>
        )}
      </div>
    </div>
  );
}
